import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'question-ui', {
    changeMyAnswer: 'Change my answer',
    next: 'Next >',
    otherPlaceholder: 'Other…',
    questionSequenceProgress: 'Question {{current}} of {{total}}',
    questionSequenceBack: 'Back',
    questionSequenceSkipAll: 'Skip all',
    questionSequenceSkipped: 'Skipped',
  });
}
